// extracted by mini-css-extract-plugin
export default {"mainCard":"Oi-z","products":"Pi-z","title":"Qi-z","heading_section":"Ri-z"};